require("./d3");
module.exports = d3;
(function () { delete this.d3; })(); // unset global



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/rickshaw/~/d3/index-browserify.js
// module id = 788
// module chunks = 0